import { render, staticRenderFns } from "./Index-3.2.vue?vue&type=template&id=60dbecb6&scoped=true&"
import script from "./Index-3.2.vue?vue&type=script&lang=js&"
export * from "./Index-3.2.vue?vue&type=script&lang=js&"
import style0 from "./Index-3.2.vue?vue&type=style&index=0&id=60dbecb6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dbecb6",
  null
  
)

export default component.exports